import React from "react";
import styled from "styled-components";
import QuantityPicker from "src/core/products/components/QuantityPicker";
import {TrashIcon} from "src/core/common/components/elements/icon/TrashIcon";

function ItemListQuantityPicker({
  quantity,
  setQuantity,
  removeItem,
  color,
  backgroundColor,
}) {
  return (
    <QuantityPicker
      quantity={quantity}
      setQuantity={setQuantity}
      render={({handleIncrement, handleDecrement}) => (
        <QuantityPickerContainer backgroundColor={backgroundColor}>
          <QuantityController onClick={handleDecrement} color={color}>
            {quantity > 1 ? "-" : <SmallTrashIcon onClick={removeItem} color={color} />}
          </QuantityController>
          <Quantity color={color}>{quantity || 0}</Quantity>
          <QuantityController onClick={handleIncrement} color={color}>
            +
          </QuantityController>
        </QuantityPickerContainer>
      )}
    />
  );
}

const QuantityPickerContainer = styled.div`
  background-color: ${({theme}) => theme.v2.overrides?.cart?.color?.surface || "#fdfefe"};
  border: 1px solid #f0f5f6;
  display: flex;
  justify-content: space-between;
  font-size: ${({theme}) => theme.v2.typography.sizing.m.lg};
  width: 120px;
  max-width: 120px;
  user-select: none;
  border-radius: 40px;

  > div {
    padding: 8px 16px;
  }
`;
const QuantityController = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${({theme}) => theme.v2.overrides?.cart?.color?.onSurface || "#8d8d8d"};
  &:active {
    color: ${({theme}) =>
      theme.v2.overrides?.cart?.color?.onSurface || theme.v2.color.primary};
  }
`;
const SmallTrashIcon = styled(TrashIcon)`
  height: 14px;
  width: 14px;
  color: ${({theme}) =>
    theme.v2.overrides?.cart?.trash?.color?.onSurface || theme.v2.color.error};
`;
const Quantity = styled.div`
  color: ${({theme}) =>
    theme.v2.overrides?.cart?.color?.onSurface || theme.v2.color.onSurface};
`;

export default ItemListQuantityPicker;
